import React from "react";
//react router
import { PersistGate } from "redux-persist/integration/react";
// import { HashRouter } from "react-router-dom";
// import { createBrowserHistory } from "history";
import { HashRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
//js
import { generateStore } from "./redux/Store";
import routes from "./config/routes";
import esES from "antd/lib/locale/es_ES";
//css
import "./assets/css/App.css";
import "moment/locale/es-mx";

function App() {
  const { store, persistor } = generateStore();
  return (
    <ConfigProvider locale={esES}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {/* <Router> */}
          <HashRouter>
            <Switch>
              {routes.map((route, i) => (
                <RoutesWithSubRoutes key={i} {...route} />
              ))}
            </Switch>
          </HashRouter>
          {/* </Router> */}
        </PersistGate>
      </Provider>
    </ConfigProvider>
  );
}

//Función que itera las rutas que van a existir en el proyecto
function RoutesWithSubRoutes(route) {
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) => <route.component routes={route.routes} {...props} />}
    />
  );
}

export default App;
